import { ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';
import { BiMenu } from 'react-icons/bi';

import Logo from 'components/logo';
import Sidebar from 'components/sidebar';
import { NavMobile } from 'components/nav-mobile';

type AppShellProps = {
  children: ReactNode;
};

function abrirMenuMobile() {
  document.dispatchEvent(new CustomEvent('openNavMobile'));
}

export default function AppShell({ children }: AppShellProps) {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' });

  if (isTabletOrMobile) {
    return (
      <>
        <NavMobile />

        <div className="flex items-center justify-between px-6 pt-6">
          <div className="w-20">
            <Logo />
          </div>

          <button type="button" aria-label="Abrir menu" onClick={abrirMenuMobile} className="text-brand-blue">
            <BiMenu size={32} />
          </button>
        </div>

        {children}
      </>
    );
  }

  return (
    // Dois níveis, como no design: o respiro da janela fica no bloco de fora e
    // o limite de 1380px no de dentro. Num nível só, o padding seria descontado
    // do próprio 1380 e estreitaria a área de conteúdo.
    <div className="px-8 pb-12 pt-8 xl:px-[72px]">
      <div className="mx-auto flex max-w-[1380px] items-stretch gap-7">
        <Sidebar />

        <main className="min-w-0 flex-1">{children}</main>
      </div>
    </div>
  );
}
